module.exports = __webpack_public_path__ + "img/A63.png";